import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHideSalesLanguage } from 'src/hooks/use-hide-sales-language';

const FF_LIST_PRICE_TREATMENT = 'ecomm.use-list-price-treatment.rollout';

export type ListPriceTreatment = {
  listPriceEnabled: boolean;
  hideSalesLanguage: boolean;
  hideStrikethrough: boolean;
  formatStandardPrice: (price: string) => string;
};

export const useListPriceTreatment = (): ListPriceTreatment => {
  const flags = useFlags();
  const listPriceEnabled = flags[FF_LIST_PRICE_TREATMENT] ?? false;
  const hideSalesLanguage = useHideSalesLanguage();

  return {
    listPriceEnabled,
    hideSalesLanguage,
    hideStrikethrough: listPriceEnabled && hideSalesLanguage,
    formatStandardPrice: (price: string) => (listPriceEnabled ? `List ${price}` : price),
  };
};
